export default __webpack_public_path__ + "static/feature3-d01eb04faba8e0b2e0fe0272e3c4f3b4.mp4";